export default __webpack_public_path__ + "static/media/whiteMain.74efc6f9.png";